import styled from 'styled-components';

import { COLORS } from '../../../../utils/theme/colors';

export const Div = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;

  @media (min-width: 480px) {
    padding-left: 24px;
    padding-right: 24px;
  }

  .ant-page-header {
    padding: 0;
  }

  .ant-page-header-heading-left {
    margin-bottom: 0;
    margin-top: 0;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 24px;
`;

export const Blank = styled.div`
  background-color: #FFF;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.21);
  padding: 24px;
  margin-left: 16px;
  margin-right: 16px;
  width: 75%;

  @media (min-width: 480px) {
    margin-left: 0;
    margin-right: 0;
  }

  a {
    color: inherit;

    &:hover {
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const ExceptionWrapper = styled.div`
  width: 25%;
  background-color: #FFF;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.21);
  padding: 24px;
  min-height: 140px;
  height: auto;
  align-self: baseline;

  .ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-btn:not(.ant-btn-primary) {
    &:hover, &:focus, &:active {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const ExceptionLine = styled.div`
  align-items: center;
  border-bottom: 1px solid #E6E7EB;
  display: flex;
  justify-content: space-between;
  padding: 8px;
  padding-right: 0;
`;

export const ExceptionInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ExceptionDescription = styled.div`
  font-weight: 300;
`;

export const WrapperWeek = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const WrapperDay = styled.div`
  padding: 12px;
  border-radius: 3px;
  border: 1px solid rgba(0,0,0,.15);
  display: flex;
  cursor: pointer;
  gap: 24px;
  overflow: hidden;
  height: 70px;

  :hover {
    border: 1px solid ${COLORS.lightDarkText};
  }
`;


export const DayLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 3px;
  background-color: rgba(0,0,0,0.6);
  color: ${COLORS.white};
  min-width: 110px;
  width: 110px;
`;

export const DaySetPrices = styled.div`
  padding: 8px;
  font-weight: 300;
  margin-left: auto;
  display: flex;
  align-items: center;

  svg {
    margin-left: 24px;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  width: 100%;
  overflow-x: scroll;

  &::-webkit-scrollbar {
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  &::-webkit-scrollbar-button:start:decrement,
  &::-webkit-scrollbar-button:end:increment {
    width: 0;
    height: 0;
    display: block;
    background-color: transparent;
  }

  &::-webkit-scrollbar-button:start:decrement:before,
  &::-webkit-scrollbar-button:end:increment:after {
    content: '';
    display: block;
    height: 5px;
    width: 5px;
    background-color: #888;
  }

  &::-webkit-scrollbar-button:start:decrement:before {
    margin-top: 3px;
  }
`;

export const Item = styled.div`
`;

export const Label = styled.div`
  color: #7f7f7f;
  font-weight: 300;
  font-size: 12px;
  white-space: nowrap;
`;

export const Value = styled.div`
  font-weight: 300;
  font-size: 14px;
  min-width: 110px;
`;

export const Title = styled.div`
  color: #4B5563;
  font-weight: 300;
  margin-bottom: 16px;
`;